module.exports = __webpack_public_path__ + "static/media/logo.alpha.6545ebc0.png";